<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col v-if="weekly" cols="2">
          <v-menu transition="scale-transition" offset-y v-model="weekMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Week starting" hide-details dense readonly v-on="on" v-model="weekAsDate" outlined append-icon="mdi-menu-down" @click:append="weekMenu=true"/>
            </template>
            <v-date-picker v-model="week" no-title :allowed-dates="day => allowedDates(day)" @change="refresh"/>
          </v-menu>
        </v-col>

        <v-col v-else cols="2">
          <v-menu transition="scale-transition" offset-y v-model="monthMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Month" hide-details dense readonly v-on="on" v-model="monthAsDate" outlined append-icon="mdi-menu-down" @click:append="monthMenu=true"/>
            </template>
            <v-date-picker v-model="month" type="month" no-title @change="refresh"/>
          </v-menu>
        </v-col>

        <v-col cols="auto" offset="1">
          <v-switch dense v-model="weekly" label="Weekly reporting" hide-details class="mt-2" @change="refresh"/>
        </v-col>

        <v-col class="text-right pr-2">
          <v-tooltip bottom open-delay="1000">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <span v-html="report()"/>
    </v-card>
  </div>
</template>

<script>
import {format,add, lastDayOfMonth, isSunday, lastDayOfWeek} from 'date-fns'
import fileSaver from 'file-saver';

export default {
  name: 'ReportsBCDSWR',
  data() {
    return {
      weekly: false,
      monthMenu: false,
      weekMenu: false,
      month: '',
      week: '',
      periodEnd: '',
      storeNumber: 0,
      bcDswr: []
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    weekAsDate() {
      return this.$formatDate(this.week);
    },
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'BCLDB Direct Sales Web Reporting')
    this.weekly = localStorage.getItem('bcdswrWeekly') === '1';

    const results = await this.$apiCall(`query ReportsBCDSWR {
                                            bcPreferences {
                                              bcPeriodEnd,storeNumber
                                            }
                                          }`);
    if (!results.error) {
      this.periodEnd = results.data.bcPreferences.bcPeriodEnd;
      this.storeNumber = results.data.bcPreferences.storeNumber;
    }

    const date = new Date();
    this.month = format(add(date, {months:-1}), 'yyyy-MM');
    this.week = format(add(date, {weeks:-1}), 'yyyy-MM-dd');
    this.refresh();
  },
  methods: {
    allowedDates(day) {
      const dp = day.split('-')
      return isSunday(new Date(dp[0],dp[1]-1,dp[2]));
    },
    async refresh() {
      localStorage.setItem('bcdswrWeekly', this.weekly ? '1' : '0');

      let from;
      let to;
      if (this.weekly) {
        const dp = this.week.split('-');
        from = this.week;
        to = format(lastDayOfWeek(new Date(dp[0],dp[1]-1,dp[2])), 'yyyy-MM-dd');
      }
      else {
        const dp = this.month.split('-');
        from = `${this.month}-01`;
        to = format(lastDayOfMonth(new Date(dp[0],dp[1]-1,1)),'yyyy-MM-dd');
      }

      const results = await this.$apiCall(`query ReportsBCDSWR($from:Date!, $to:Date!) {
                                             bcDswr(from:$from, to:$to) {
                                               type,date,invoice,original,customerNumber,customerType,sku,quantity,price,containerDeposit
                                             },
                                           }`,
                                           {from, to});
      if (!results.error)
        this.bcDswr = results.data.bcDswr;
    },

    report() {
      if (!this.bcDswr)
        return '';
      const lines = [`<style>
                @page {size:landscape}
                .report {font-family: Roboto, sans-serif; font-size:12px;width:100%;border-spacing:0;border-collapse:collapse}
                .report .title {font-weight:700;font-size:18px;text-align:left}
                .report .sub-title {text-align:left}
                .report tr {
                  height:25px;
                  vertical-align:bottom;
                }
                .report .header {
                  font-weight:bold;
                }
                .report td {
                  border: 1px solid #000;
                  padding-left:5px;
                  padding-right:5px;
                }
              </style>
              <table class="report">
                <thead>
                  <tr>
                    <th colspan="5" class="title">Direct Sales Web Reporting</th>
                  </tr>
                  <tr>
                    <th colspan="5" class="sub-title">${this.monthAsDate}</th>
                  </tr>
                  <tr><th colspan="5">&nbsp;</th></tr>
                </thead>
                <tbody>
                  <tr class="header">
                    <td>Store_Number</td>
                    <td>Transaction_Type</td>
                    <td>Transaction_Date</td>
                    <td>Invoice_Reference_Number</td>
                    <td>Original_Invoice_Number</td>
                    <td>Customer_Number</td>
                    <td>Customer_Type</td>
                    <td>Payment_Method</td>
                    <td>SKU</td>
                    <td>Quantity</td>
                    <td>Display_Price</td>
                    <td>Container_Deposit</td>
                    <td>Total_Doc_Amount</td>
                    <td>Return_Reason_Code</td>
                  </tr>`];
      for (const line of this.bcDswr)
        lines.push(`<tr>
                      <td class="text-right">${this.storeNumber}</td>
                      <td >${line.type}</td>
                      <td >${line.date}</td>
                      <td class="text-right">${line.invoice}</td>
                      <td class="text-right"></td>
                      <td class="text-right">${line.customerNumber}</td>
                      <td>${line.customerType}</td>
                      <td></td>
                      <td>${line.sku}</td>
                      <td class="text-right">${line.quantity}</td>
                      <td class="text-right">${this.$number(line.price,2)}</td>
                      <td class="text-right">${this.$number(line.containerDeposit, 2)}</td>
                      <td class="text-right">${this.$number(line.containerDeposit + line.quantity*line.price, 2)}</td>
                      <td></td>
                    </tr>`);
      lines.push(`</tbody>
               </table>`);
      return lines.join('');
    },

    exportCSV() {
      const title = `Store_${this.storeNumber}_${format(new Date(), 'MMddyyyy')}_1`;

      const lines = ['Store_Number,Transaction_Type,Transaction_Date,Invoice_Reference_Number,Original_Invoice_Number,Customer_Number,Customer_Type,Payment_Method,SKU,Quantity,Price,Container_Deposit,Total_Doc_Amount,Return_Reason_Code'];
      for (const line of this.bcDswr)
        lines.push(`${this.storeNumber},${line.type},${line.date},${line.invoice},,${line.customerNumber},${line.customerType},,${line.sku},${line.quantity},${this.$number(line.price,2)},${this.$number(line.containerDeposit, 2)},${this.$number(line.containerDeposit + line.quantity*line.price, 2)}`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, `${title}.csv`);
    },
  }
}
</script>